import {Component, ElementRef, ViewChild} from '@angular/core';
import {Events, IonicPage, NavController, NavParams, Slides} from 'ionic-angular';
import * as moment from "moment";
import {ApiProvider} from "../../providers/api/api";
import { Chart } from 'chart.js';

/**
 * Generated class for the AppStatsFoodPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-app-stats-food',
  templateUrl: 'app-stats-food.html',
})
export class AppStatsFoodPage {
  weeks: Array<any>;
  @ViewChild(Slides) slides: Slides;
  @ViewChild('extraPager') pagerWrapper: ElementRef;
  @ViewChild('chartGeneral') generalChart;
  activeIndex: number;
  weeklyView: boolean;
  selectedCurrentWeekView: string = 'today';

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private api: ApiProvider,
    private events: Events
  ) {
    this.weeks = new Array<any>();
    var today = moment();
    today.subtract(parseInt(today.format('E'))-1, 'days');
    let weekCount = 20;

    for(var i = 0; i < weekCount;i++) {
      var end = today.clone();
      end.add(6,'days');
      var label = today.format('D. MMM')+' - '+end.format('D. MMM');
      if(i == 0) {
        label = 'Diese Woche';
      }
      if(i == 1) {
        label = 'Letzte Woche';
      }
      this.weeks.push(
        {
          index: i,
          start: today.format('YYYY-MM-DD'),
          end: end.format('YYYY-MM-DD'),
          label: label,
          active: false,
          currentWeek: (i==0),
          data: {}
        }
      )

      today.subtract(7, 'days');
    }
    this.weeks = this.weeks.reverse();
    this.loadUiData();

    this.events.subscribe('stats:food:update', () => {
      this.loadUiData();
    })
  }

  switchCurrentWeekMode($event) {
    console.log($event);
    if (typeof $event === 'string') {
      this.selectedCurrentWeekView = $event;
    } else if ($event && $event.value) {
      this.selectedCurrentWeekView = $event.value;
    }
  }

  loadUiData() {
    this.api.callGet('/food').subscribe((response) => {
      console.log('food data endpoint response', this.weeks, response);
      for(var k in response) {
        var item = response[k];
        for(var l in this.weeks) {
          if(this.weeks[l].start <= item.date && this.weeks[l].end >= item.date) {
            var weekNum = moment(item.date, ).format('E');
            this.weeks[l].data[weekNum] = {
              group1: parseInt(item.groupWater) + parseInt(item.groupVegetables) + parseInt(item.groupFruit) + parseInt(item.groupGrainProducts),
              group2: parseInt(item.groupOilFat) + parseInt(item.groupMilkProducts) + parseInt(item.groupNuts) + parseInt(item.groupMeatEgg),
              group3: parseInt(item.groupSnacks),
            }
          }
        }
      }

      for (var l in this.weeks) {
        var weekGraphs = {
          'group1': {gradients: [], points: []},
          'group2': {gradients: [], points: []},
          'group3': {gradients: [], points: []},
        }
        for(var m in this.weeks[l].data) {
          var groupItem = this.weeks[l].data[m];

          if(groupItem.group1) {
            weekGraphs['group1']['points'].push({x: parseInt(m), y: Math.max(Math.min(groupItem.group1, 18), 0)})
          }
          if(groupItem.group2) {
            weekGraphs['group2']['points'].push({x: parseInt(m), y: Math.max(Math.min(groupItem.group2, 18), 0)})
          }
          if(groupItem.group3) {
            weekGraphs['group3']['points'].push({x: parseInt(m), y: Math.max(Math.min(groupItem.group3, 18), 0)})
          }
        }
        this.weeks[l]['graphs'] = weekGraphs
      }
      console.log(this.weeks);
      this.loadChartsForCurrentIndex();
    })
  }

  getGraphConfigTemplate () {
    return {
      type: 'scatter',
      data: {
        labels: ['M','D','M','D','F','S','S'],
        datasets: [{
          data: [], //(weekData['graphs'] && weekData['graphs']['group1'])?weekData['graphs']['group1']['points']:[],
          borderColor: '#55a446',// array should have same number of elements as number of dataset
          borderWidth: 6,
          pointRadius: 1,
          pointBorderWidth: 4,
          fill: false,
          showLine: true,
        },{
          data: [], //(weekData['graphs'] && weekData['graphs']['group2'])?weekData['graphs']['group2']['points']:[],
          borderColor: '#ed9800',// array should have same number of elements as number of dataset
          borderWidth: 6,
          pointRadius: 1,
          pointBorderWidth: 4,
          fill: false,
          showLine: true
        },{
          data: [], //(weekData['graphs'] && weekData['graphs']['group2'])?weekData['graphs']['group2']['points']:[],
          borderColor: '#d2442e',// array should have same number of elements as number of dataset
          borderWidth: 6,
          pointRadius: 1,
          pointBorderWidth: 4,
          fill: false,
          showLine: true
        }]
      },
      /*plugins: [{
        beforeRender: (x, options) => {
          const c = x.chart;
          const dataset = x.data.datasets[0];
          const yScale = x.scales['y-axis-0'];
          const yPos = 10;

          const gradientFill = c.ctx.createLinearGradient(0, 0, 0, c.height);
          gradientFill.addColorStop(0, 'rgb(86,188,77)');
          gradientFill.addColorStop(yPos / c.height, 'rgb(86,188,77)');
          gradientFill.addColorStop(yPos / c.height, 'rgb(229,66,66)');
          gradientFill.addColorStop(1, 'rgb(229,66,66)');

          const model = x.data.datasets[0]._meta[Object.keys(dataset._meta)[0]].dataset._model;
          model.borderColor = gradientFill;
        },
      }],*/
      options: {
        aspectRatio: 1,
        elements: {
          line: {
            tension: 0
          }
        },
        layout: {
          padding: {
            left: 20,
            right: 20,
          }
        },

        plugins: {
          title: {
            display: false,
          },
          legend: {
            display: false,
          }
        },
        scales: {
          xAxes: [{
            gridLines: {
              display: false
            },
            ticks: {
              min: 1,
              max: 7,
              stepSize: 1,
              callback: function(key) {
                  return ['M','D','M','D','F','S','S'][key-1];
              }
            },
          }],
          yAxes: [{
            ticks: {
              mirror: true,
              stepSize: 1,
              suggestedMax: 10,
              padding: 20,
              beginAtZero: true,
            }
          }]
        }
      }
    };
  }

  loadChartsForCurrentIndex() {
    console.log('loadChartsForCurrentIndex')
    var slideContainer = this.slides._slides[this.slides.getActiveIndex()];
    Chart.defaults.global.legend.display = false;

    var weekData = this.weeks[this.slides.getActiveIndex()];
    console.log(this.weeks, slideContainer, slideContainer.querySelector('.chart-general'), weekData, weekData['start'], weekData['graphs']);

    if(!weekData.generalBar) {
      weekData.generalBar = new Chart(slideContainer.querySelector('.chart-general'), this.getGraphConfigTemplate());
    }
    if(!weekData.group1Bar) {
      var graphConfig = this.getGraphConfigTemplate();
      graphConfig.data.datasets = [graphConfig.data.datasets[0]];
      weekData.group1Bar = new Chart(slideContainer.querySelector('.chart-group-1'), graphConfig);
    }
    if(!weekData.group2Bar) {
      var graphConfig = this.getGraphConfigTemplate();
      graphConfig.data.datasets = [graphConfig.data.datasets[1]];
      graphConfig.options.scales.yAxes[0].ticks.suggestedMax = 10;
      weekData.group2Bar = new Chart(slideContainer.querySelector('.chart-group-2'), graphConfig);
    }
    if(!weekData.group3Bar) {
      var graphConfig = this.getGraphConfigTemplate();
      graphConfig.data.datasets = [graphConfig.data.datasets[2]];
      graphConfig.options.scales.yAxes[0].ticks.suggestedMax = 4;
      weekData.group3Bar = new Chart(slideContainer.querySelector('.chart-group-3'), graphConfig);
    }
    if (weekData['graphs'] && weekData['graphs']['group1']) {
      weekData.generalBar.data.datasets[0].data = weekData['graphs']['group1']['points'];
      weekData.generalBar.update();
      weekData.group1Bar.data.datasets[0].data = weekData['graphs']['group1']['points'];
      weekData.group1Bar.update();
      console.log('update graph', weekData.generalBar.data.datasets[0].data);
    }
    if (weekData['graphs'] && weekData['graphs']['group2']) {
      weekData.generalBar.data.datasets[1].data = weekData['graphs']['group2']['points'];
      weekData.generalBar.update();
      weekData.group2Bar.data.datasets[0].data = weekData['graphs']['group2']['points'];
      weekData.group2Bar.update();
      console.log('update graph 2', weekData.generalBar.data.datasets[1].data);
    }
    if (weekData['graphs'] && weekData['graphs']['group3']) {
      weekData.generalBar.data.datasets[2].data = weekData['graphs']['group3']['points'];
      weekData.generalBar.update();
      weekData.group3Bar.data.datasets[0].data = weekData['graphs']['group3']['points'];
      weekData.group3Bar.update();
      console.log('update graph 3', weekData.generalBar.data.datasets[2].data);
    }

  }

  ngAfterViewInit() {

    this.slides.ionSlideDidChange.subscribe(($event) => {
      this.loadChartsForCurrentIndex();
    })
    this.slides.ionSlideWillChange.subscribe(($event) => {
      var previousIndex = this.slides.getPreviousIndex();
      var activeIndex = this.slides.getActiveIndex();
      this.activeIndex = this.slides.getActiveIndex();
      if(activeIndex >= this.weeks.length) {
        return ;
      }
      if(this.weeks[previousIndex]) {
        this.weeks[previousIndex].active = false;
      }
      this.weeks[activeIndex].active = true;
      let pageLength = 200;
      if((window as any).innerWidth <= 320) {
        pageLength = 140;
      }
      this.pagerWrapper.nativeElement.style.marginLeft = (activeIndex*pageLength*-1+((document.body.offsetWidth-pageLength)/2))+'px';
    })

    console.log('ngAfterInitView', new Date().toISOString());
  }


  goToSlide(slide) {
    this.slides.slideTo(this.weeks.indexOf(slide));
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AppStatsFoodPage');
  }
  abs(a: number) {
    return Math.abs(a);
  }

  showTrends() {
    this.events.publish('app:show-food-trends');
  }

}



// WEBPACK FOOTER //
// ./src/pages/app-stats-food/app-stats-food.ts